import styled, { css } from 'styled-components';
import theme from '../../theme';

const Container = styled.div<{
    $error: boolean;
}>`
    display: flex;
    justify-content: center;
    flex-direction: column;

    label {
        font-size: 12px;
        font-weight: 500;
        color: ${theme.textDark};
        margin-bottom: 2px;

        span {
            margin-left: 2px;
            color: #CF384B;
        }
    }

    input {
        height: 32px;
        border-radius: 3px;
        padding: 4px 8px;
        border: 1px solid ${theme.textLight};
        font-size: 13px;
        font-weight: 400;
        color: ${theme.textDark};

        ${props => props.$error && css`
            border: 1px solid ${theme.errorColor};
        `}

        &::placeholder {
            font-size: 13px;
            font-weight: 400;
            color: ${theme.textLight};
        }
    }

    > div {
        display: flex;
        justify-content: center;
        flex-direction: column;
        position: relative;

        svg {
            position: absolute;
            top: 13px;
            right: 7px;
            cursor: pointer;
        }
    }
`;

const ErrorMessage = styled.span`
    font-size: 11px;
    font-weight: 400;
    color: ${theme.errorColor} !important;
    margin: 0;
`;

const DetailMessage = styled.span<{
    $characterlimitExceeded: boolean;
}>`
    font-size: 11px;
    font-weight: 400;
    color: black;
    margin: 0;

    ${({ $characterlimitExceeded }) => $characterlimitExceeded && css`
        color: ${theme.errorColor};
    `};
`;

export { Container, ErrorMessage, DetailMessage };